import _ from 'lodash';
export function checkIfHasBudget() {
    let budgetStore = JSON.parse(localStorage.getItem('budgetB2b'));
    if(budgetStore) {
        let shoppingCart = budgetStore.shoppingCart;
        let operations = shoppingCart.operations;
        let parts = shoppingCart.parts;
        let concatOperationLists = operations.maintenance.concat(operations.repair);
        let checkParts = _.isEmpty(parts);
        return !(concatOperationLists.length <= 0 && checkParts);
    } else {
        return false;
    }
};
